import type { ClerkProviderProps } from "@clerk/react";

/** UserProfile modal overrides: Clerk upload controls are replaced by DiceBear. */
export const morrowClerkUserProfileAppearance = {
  elements: {
    avatarImageActions: {
      display: "none",
    },
    fileDropAreaButton: {
      display: "none",
    },
  },
} satisfies NonNullable<ClerkProviderProps["appearance"]>;
